import * as React from 'react';
import { useEffect, useState } from 'react';
// @ts-ignore
import styles from './CaseChatCreateMessage.module.scss';
import { joinClasses } from '../../Utils/className.util';
import heic2any from 'heic2any';
import Loading from '../Loading';

interface CaseChatCreateMessageFilePreviewProps {
	removeFile: () => void;
	selectedFile: any;
}

export default function CaseChatCreateMessageFilePreview(
	props: CaseChatCreateMessageFilePreviewProps,
) {
	const [filePreview, setFilePreview] = useState(null);
	const [processing, setProcessing] = useState(false);
	const [filePreviewSize, setFilePreviewSize] = useState('cover');
	const { removeFile, selectedFile } = props;

	useEffect(() => {
		if (selectedFile && selectedFile?.type?.search('image/') !== -1) {
			if (
				selectedFile.type === 'image/heic' ||
				selectedFile.type === 'image/heif'
			) {
				setProcessing(true);
				setFilePreview(null);
				heic2any({
					blob: selectedFile,
				})
					.then(conversionResult => {
						// @ts-ignore
						setFilePreview(URL.createObjectURL(conversionResult));
						setFilePreviewSize('cover');
						setProcessing(false);
					})
					.catch(e => {
						setFilePreview('/dist/file.png');
						setFilePreviewSize('auto');
						setProcessing(false);
					});
			} else {
				setFilePreview(URL.createObjectURL(selectedFile));
				setFilePreviewSize('cover');
			}
		} else {
			setFilePreview('/dist/file.png');
			setFilePreviewSize('auto');
		}
	}, [selectedFile]);

	return (
		<div className='multi-image-preview__wrapper'>
			<div className='multi-image-preview__files row'>
				{selectedFile && (
					<div
						className={joinClasses([
							'multi-image-preview__files__file uploadifive-queue-item',
							styles.filePreview,
						])}
					>
						<img
							className={styles.removeButton}
							src={'/dist/icons/close.svg'}
							onClick={removeFile}
						/>
						<div
							className={joinClasses([
								'multi-image-preview__files__file__preview',
								styles.filePreviewBackground,
							])}
							style={{
								backgroundSize: filePreviewSize,
								backgroundImage: filePreview
									? 'url(' + filePreview + ')'
									: undefined,
							}}
						>
							{processing && <Loading />}
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
